module.exports = __webpack_public_path__ + "static/img/top-banner1.00d4a62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top-banner1.jpg
// module id = W6gg
// module chunks = 73